// Workplace Communication Research (2026-02) — the "Book a
// Conversation" completion-screen CTA opens this picker so the
// visitor chooses which real, existing booking journey to enter
// (Presentation / Executive Presence / Corporate). Radix Dialog
// already gives us: focus trap while open, focus restored to the
// triggering button on close, and close via the X control, Escape,
// or an outside click — so none of that needs reimplementing here.
import { Link } from "react-router-dom";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ROUTES } from "@/config/links";

export const BookingPickerModal = ({ open, onOpenChange, rt, rl, triggerRef }) => {
  const options = [
    { key: "presentation", label: rt("booking_option_presentation"), to: rl(ROUTES.bookPresentation) },
    { key: "executive_presence", label: rt("booking_option_executive_presence"), to: rl(ROUTES.bookExecutivePresence) },
    { key: "corporate", label: rt("booking_option_corporate"), to: rl(ROUTES.bookCorporate) },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-sm"
        data-testid="research-booking-modal"
        onCloseAutoFocus={(event) => {
          // No <DialogTrigger> is used here (the dialog is opened from
          // controlled state on the completion screen's own CTA button,
          // not a Radix trigger), so Radix has no triggerRef of its own
          // to restore focus to — do it explicitly instead.
          event.preventDefault();
          triggerRef?.current?.focus();
        }}
      >
        <DialogHeader>
          <DialogTitle data-testid="research-booking-modal-title">{rt("booking_modal_heading")}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2 pt-1">
          {options.map((opt) => (
            <Link
              key={opt.key}
              to={opt.to}
              onClick={() => onOpenChange(false)}
              data-testid={`research-booking-option-${opt.key}`}
              className="w-full rounded-md border border-input px-4 py-3 text-left text-sm font-medium transition-colors hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring"
            >
              {opt.label}
            </Link>
          ))}
        </div>
        <DialogClose asChild>
          <Button variant="ghost" className="mt-2 w-full" data-testid="research-booking-modal-close">
            {rt("booking_modal_close")}
          </Button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
};
